import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProgramQueryObject, RegistedBranchQueryObject } from 'src/app/shared/models/queryObject';
import { ProgramService } from 'src/app/shared/service/ManageDelivery/program.service';
import { RegistedBranchService } from 'src/app/shared/service/ManageDelivery/registed-branch.service';
import { AlertyfyService } from 'src/app/shared/service/alertyfy.service';
import { environment } from 'src/environments/environment';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
@Component({
  selector: 'app-list-registed-branch',
  templateUrl: './list-registed-branch.component.html',
  styleUrls: ['./list-registed-branch.component.scss']
})
export class ListRegistedBranchComponent implements OnInit {

  showFilters: Boolean = false;
  noDataFound: string;
  queryObject = new RegistedBranchQueryObject();
  pageSize = environment.pageSize;

  columns = [
    { title: 'Name', key: 'Name', isSortable: true },
    { title: 'Description', key: 'Description', isSortable: true },
    { title: 'Action' }

  ];
  programList: [];

  constructor(private alertyfy: AlertyfyService, private _router: Router, private programService: RegistedBranchService) { }

  ngOnInit(): void {
    this.noDataFound = environment.noDataFound;
    this.queryObject.page = 1;
    this.queryObject.pageSize = 10;
    this.getRegistedBranch();
  }

  onDeleteConfirm(id) {
    this.alertyfy.confirm(
      "Are you sure you want to delete?",
      () => {
        this.programService.delete(id)
          .subscribe(res => {
            this.alertyfy.success("Deleted Successfully.");
            this.getRegistedBranch();
          },
            (error) => {
              this.alertyfy.error(error);
            })

      });
  }

  getRegistedBranch() {
    this.programService.search(this.queryObject).subscribe(res => {
      this.programList = res.items;
      this.queryObject.pageCount = res.totalItems;
    });
  }

  showHideFilter() {
    this.showFilters = !this.showFilters;
  }

  sortBy(columnName) {
    if (this.queryObject.sortBy === columnName) {
      this.queryObject.isSortAsc = !this.queryObject.isSortAsc;
    } else {
      this.queryObject.sortBy = columnName;
      this.queryObject.isSortAsc = true;
    }
    // this.loadCountry();
  }

  onPageChange(page) {
    this.queryObject.page = page;
    this.getRegistedBranch();
  }

  onCreateConfirm() {
    this._router.navigateByUrl('/managedelevery/create-registed-branch');
  }
  public exportToExcel(flag: boolean) {

    // this.queryObject.printall = flag;
    // this.countryService.exportAllItemsToExcel(this.queryObject).subscribe((res: Blob) => {
    //   importedSaveAs(res, 'CountryList.xlsx');
    // });
  }
  public exportToPdf(flag: boolean) {
    // this.queryObject.printall = flag;
    // this.countryService.exportAllItemsToPDF(this.queryObject).subscribe((res: Blob) => {
    //   importedSaveAs(res, 'CountryList.pdf');
    // });
  }
  public Search() {
    this.getRegistedBranch();
  }

  public Reset() {
    this.queryObject.isSortAsc = true;
    this.queryObject.sortBy = '';
    this.queryObject.searchString = '';
    this.queryObject.page = 1;
    this.queryObject.pageSize = this.pageSize;
    this.getRegistedBranch();
  }
}
